import React from 'react'
import LeaveAllotment from '../Components/LeaveManagement/LeaveAllotment/LeaveAlotment'

const LeaveAllotmentPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <LeaveAllotment/>
    </div>
  )
}

export default LeaveAllotmentPage
